import apiClient from '@/utils/axios'

import {Testimonial} from '@/types'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'

const {TESTIMONIAL_URL} = apiEndPoints

interface TestimonialService {
  get(): Promise<AxiosResponse<Testimonial[]>>
  getById(id: string): Promise<AxiosResponse<Testimonial>>
  create(payload: FormData): Promise<AxiosResponse<Testimonial>>
  update(testimonial: FormData, id: string): Promise<AxiosResponse<Testimonial>>
  delete(id: string): Promise<AxiosResponse<string>>
  updatePosition(testimonial: Testimonial): Promise<AxiosResponse<Testimonial>>
}

const testimonial: TestimonialService = {
  async get(): Promise<AxiosResponse<Testimonial[]>> {
    const response = await apiClient.get(TESTIMONIAL_URL)
    return response
  },

  async getById(id: string): Promise<AxiosResponse<Testimonial>> {
    const response = await apiClient.get(`${TESTIMONIAL_URL}/${id}`)
    return response
  },

  async create(payload: FormData): Promise<AxiosResponse<Testimonial>> {
    const response = await apiClient.post(TESTIMONIAL_URL, payload)
    return response
  },

  async update(testimonial: FormData, id: string): Promise<AxiosResponse<Testimonial>> {
    // const id = VueCookies.get('testimonial')
    const response = await apiClient.put(`${TESTIMONIAL_URL}/${id}`, testimonial)
    return response
  },

  async delete(id: string): Promise<AxiosResponse<string>> {
    const response = await apiClient.delete(`${TESTIMONIAL_URL}/${id}`)
    return response
  },

  async updatePosition(testimonial: Testimonial): Promise<AxiosResponse<Testimonial>> {
    const response = await apiClient.patch(`${TESTIMONIAL_URL}/${testimonial.id}`, testimonial)
    return response
  },
}

export {testimonial}
